import React, { Component, createRef } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import validate from "../../common/validation";

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Table,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addCategories,
  deleteCategories,
  getCategories,
  updateCategories,
} from "api";
import { withTranslation } from "react-i18next";
import { warning } from "toastr";

class Category extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      notEditableRows: [],
      stockList: [],
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
    this.comsumptionType = [
      { value: "1", label: "1 Time" },
      { value: "2", label: "2 Time" },
      { value: "3", label: "3 Time" },
      { value: "4", label: "Multiple Time" },
    ];
  }

  async componentDidMount() {
    this.categoryAllGet();
  }

  async categoryAllGet() {
    const data = await getCategories({ page: null, limit: null });

   if(data.data){
      this.setState({
        stockList: data.data,
        notEditableRows: data.data.map(x => x.id),
      });
    }
  }

  async update(row) {
    console.log(row);
    if ("createdAt" in row) {
      delete row.description;
      const data = await updateCategories({
        ...row,
      });
      if (data.success == true) {
        this.categoryAllGet();
      }
    } else {
      let temp = {
        ...row,
      };
      if(temp.name.length > 0){
        const data = await addCategories(temp);
        if (data.success == true) {
          this.categoryAllGet();
        }
      } else {
        warning("Please Enter Inclusion Name")
      }
      
    }
  }

  async deleteRow(rowIndex, row) {
    this.state.stockList.splice(rowIndex, 1);
    this.setState({
      stockList: this.state.stockList,
      notEditableRows: this.state.stockList.map((x, index) => x.id),
    });
    const data = await deleteCategories(row.id);
    if (data.success == true) {
      this.categoryAllGet();
    }
  }

  addRow() {
    let max = parseInt(
      this.state.stockList.reduce((prev, curr) => {
        return parseInt(curr.id) < parseInt(prev.id) ? prev : curr;
      }).id
    );
    this.setState({
      stockList: [
        ...this.state.stockList,
        {
          id: max + 1,
          name: "",
        },
      ],
      notEditableRows: [...this.state.notEditableRows, (max + 1)],
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const modifiedV = { ...this.state.validation };

    this.setState({ validation: modifiedV });
  }

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    this.columns1 = [
      {
         text: `${this.props.t("Sr.No.")}`,
        footer: `${this.props.t("Total")}`,
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
      },
      {
        dataField: "name",
        text: `${this.props.t("Name")}`,
        footer: "",
      },
      {
        dataField: "edit",
        text: `${this.props.t("Edit Data")}`,
        footer: "",
        editable: true,

        editorRenderer: (
          editorProps,
          value,
          row,
          column,
          rowIndex,
          columnIndex
        ) => {
          return (
            <div className="btn-group">
              {!this.state.notEditableRows.includes(row.id) ? (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    this.setState({
                      notEditableRows: [...this.state.notEditableRows, row.id],
                    });
                    this.update(row);
                  }}
                >
                  <img src="images/dashboard-images/print.svg"></img>
                </span>
              ) : (
                <span
                  className="border-0 rounded ms-2"
                  onClick={() => {
                    if (
                      this.state.notEditableRows.length ===
                      this.state.stockList.length
                    )
                      this.setState({
                        notEditableRows: this.state.notEditableRows.filter(
                          x => x != row.id
                        ),
                      });
                  }}
                >
                  <img src="images/dashboard-images/edit.svg"></img>
                </span>
              )}
              <button
                className="bg-transparent border-0 ms-3"
                onClick={() => this.deleteRow(rowIndex, row)}
              >
                <img src="images/dashboard-images/deleteRow.svg"></img>
              </button>
            </div>
          );
        },
        formatter: (cell, row, rowIndex) => (
          <div className="btn-group">
            {!this.state.notEditableRows.includes(row.id) ? (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  this.setState({
                    notEditableRows: [...this.state.notEditableRows, row.id],
                  });
                  this.update(row);
                }}
              >
                <img src="images/dashboard-images/print.svg"></img>
              </span>
            ) : (
              <span
                className="border-0 rounded ms-2"
                onClick={() => {
                  if (
                    this.state.notEditableRows.length ===
                    this.state.stockList.length
                  )
                    this.setState({
                      notEditableRows: this.state.notEditableRows.filter(
                        x => x != row.id
                      ),
                    });
                }}
              >
                <img src="images/dashboard-images/edit.svg"></img>
              </span>
            )}
            <button
              className="bg-transparent border-0 ms-3"
              onClick={() => this.deleteRow(rowIndex, row)}
            >
              <img src="images/dashboard-images/deleteRow.svg"></img>
            </button>
          </div>
        ),
      },
    ];

    document.title = "manage stock";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem="Category" />
            <Card>
              <div className="row px-3 pt-4">
                <div className="d-flex justify-content-between">
                  <h3 className="fw-bold pb-3 text-black">Category</h3>
                  <button
                    type="button"
                    className="bg-transparent border-0"
                    onClick={() => this.addRow()}
                  >
                    <img
                      src="images/dashboard-images/addRow.svg"
                      alt="add Row"
                    />
                  </button>
                </div>

                <div className="table-responsive">
                  <BootstrapTable
                    classes="foo"
                    keyField="id"
                    headerClasses="background-light fs-5"
                    footerClasses="background-light fs-5"
                    bootstrap4={true}
                    data={this.state.stockList}
                    columns={this.columns1}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                      nonEditableRows: () => this.state.notEditableRows,
                    })}
                  />
                </div>
              </div>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(Category);
